import { FC, ReactNode } from "react";
import Typography from "../Typography";

export type ReasonsMiniGridItem = {
  icon: ReactNode;
  h3: ReactNode;
  body: ReactNode;
};

type ReasonsMiniGridProps = {
  sectionTitle: ReactNode;
  features: ReasonsMiniGridItem[];
};

// 3-card grid used at the top of pages 12 and 17 ("3 reasons creators
// use Klap's highlight video maker"). Visually distinct from
// FeatureGrid: 3 columns, taller cards, larger icons, no surrounding
// background tint so it reads as a hero-adjacent "value props" row
// rather than a deep-page feature catalog.
const ReasonsMiniGrid: FC<ReasonsMiniGridProps> = ({
  sectionTitle,
  features,
}) => {
  return (
    <section className="max-w-[1500px] px-3 md:px-12 mx-auto my-24 md:my-32 text-center">
      <Typography
        variant="h2"
        component="h2"
        className="max-w-3xl mx-auto"
      >
        {sectionTitle}
      </Typography>
      <div className="mt-12 grid grid-cols-1 md:grid-cols-3 gap-8 text-left">
        {features.map((feature, index) => (
          <article
            key={index}
            className="rounded-2xl bg-white border border-slate-200 p-8 flex flex-col gap-4"
          >
            <span className="w-12 h-12 shrink-0 flex items-center justify-center rounded-xl bg-violet-100 text-violet-600 [&>svg]:w-6 [&>svg]:h-6">
              {feature.icon}
            </span>
            <Typography variant="h5" component="h3">
              {feature.h3}
            </Typography>
            <Typography
              variant="body2"
              className="text-slate-500 leading-relaxed"
            >
              {feature.body}
            </Typography>
          </article>
        ))}
      </div>
    </section>
  );
};

export default ReasonsMiniGrid;
